import { render, staticRenderFns } from "./LabelTypeSelection.vue?vue&type=template&id=8860392e&scoped=true"
import script from "./LabelTypeSelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./LabelTypeSelection.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8860392e",
  null
  
)

export default component.exports